import { render, staticRenderFns } from "./ExpensesComponent.vue?vue&type=template&id=0f620d7e"
import script from "./ExpensesComponent.vue?vue&type=script&lang=js"
export * from "./ExpensesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports